import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/premium-hub/appEnv';

export default appStarterFactory(appEnv);
